import { useState } from "react";
import { useTranslation } from "react-i18next";
import { getMonthsAgo } from "../../../components/formatted/FormattedDateAndTime";

/**
 * Hook pour gérer la période des statistiques (modal caractérisations).
 */
export const useStatisticsPeriod = () => {
  const { t } = useTranslation();
  const now = new Date();
  const sixMonthsAgo = new Date(now);
  sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
  sixMonthsAgo.setHours(0, 0, 0, 0);

  const [periodHistoryStop, setPeriodHistoryStop] = useState(now.toISOString());
  const [periodHistoryStart, setPeriodHistoryStart] = useState(
    sixMonthsAgo.toISOString(),
  );
  const [periodHistoryStopPrevious, setPeriodHistoryStopPrevious] = useState(
    getMonthsAgo(now, 7, true).toISOString(),
  );
  const [periodHistoryStartPrevious, setPeriodHistoryStartPrevious] = useState(
    getMonthsAgo(now, 12).toISOString(),
  );
  const [periodFilter, setPeriodFilter] = useState(6);
  const [periodDisplayLabel, setPeriodDisplayLabel] = useState(() =>
    t("Last 6 months"),
  );
  const [handleValidate, setHandleValidate] = useState(false);

  const applyPeriod = (months, label, startDateIso, endDateIso) => {
    setPeriodFilter(months ?? null);
    setPeriodDisplayLabel(label || t("Last 6 months"));
    if (startDateIso && endDateIso) {
      setPeriodHistoryStart(startDateIso);
      setPeriodHistoryStop(endDateIso);
    }
  };

  return {
    periodHistoryStart,
    setPeriodHistoryStart,
    periodHistoryStop,
    setPeriodHistoryStop,
    periodHistoryStartPrevious,
    setPeriodHistoryStartPrevious,
    periodHistoryStopPrevious,
    setPeriodHistoryStopPrevious,
    periodFilter,
    periodDisplayLabel,
    applyPeriod,
    handleValidate,
    setHandleValidate,
  };
};
